export const catalog_matrix = [
  {form_key:'status_id', catalog_key:'patient_statuses'},
  {form_key:'inactive_reason_id', catalog_key:'inactive_reasons'},
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]